var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6798 14.0197C36.0111 5.91009 28.0841 0.688771 19.9745 2.3575C13.0304 3.78647 8.03673 9.88451 8.00487 16.9739C8.00487 17.3117 8.01884 17.6576 8.04882 18.0233C3.10868 18.5463 -0.472212 22.9749 0.0507075 27.9151C0.535399 32.494 4.39972 35.9676 9.00424 35.9631H10.0536C10.0297 35.6313 10.0037 35.3015 10.0037 34.9637C10.0037 27.7881 15.8207 21.9711 22.9963 21.9711C30.1719 21.9711 35.9888 27.7881 35.9888 34.9637C35.9888 35.3014 35.9628 35.6312 35.9389 35.9631H36.9883C43.0532 35.9797 47.9833 31.0765 47.9999 25.0114C48.0159 19.1918 43.489 14.3703 37.6798 14.0197Z",
    fill: "#F5F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9937 45.9561C29.0653 45.9561 33.9874 41.0341 33.9874 34.9624C33.9874 28.8908 29.0653 23.9688 22.9937 23.9688C16.922 23.9688 12 28.8908 12 34.9624C12 41.0341 16.922 45.9561 22.9937 45.9561Z",
    fill: "url(#paint0_linear_15422_21916)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9916 41.9569C22.4397 41.9569 21.9922 41.5094 21.9922 40.9574V28.9643C21.9922 28.4123 22.4397 27.9648 22.9916 27.9648C23.5436 27.9648 23.9911 28.4123 23.9911 28.9643V40.9574C23.991 41.5094 23.5436 41.9569 22.9916 41.9569Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9895 33.9603C26.7243 33.9608 26.4697 33.8558 26.2819 33.6684L22.9918 30.3763L19.7016 33.6684C19.3046 34.0519 18.6719 34.0409 18.2884 33.6439C17.9143 33.2565 17.9143 32.6425 18.2884 32.2552L22.2862 28.2575C22.6764 27.8673 23.309 27.8673 23.6994 28.2575L27.6971 32.2552C28.0868 32.6461 28.0859 33.2789 27.6949 33.6686C27.5077 33.8553 27.254 33.9602 26.9895 33.9603Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15422_21916",
    x1: 13.5778,
    y1: 18.6682,
    x2: 34.5114,
    y2: 20.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon2);
export default __webpack_public_path__ + "static/media/upload-icon-2.c3091f1a13492182569264785f4a320f.svg";
export { ForwardRef as ReactComponent };